import React, { useState, useEffect } from 'react';
import './HeroSection.css';

const HeroSection = ({ onNavigateToPostRFQ, onNavigateToJoinFreelancer, onNavigateToBrowseRFQs, onNavigateToBusinessContact }) => {
  const [currentImage, setCurrentImage] = useState(0);

  // Background images for carousel
  const backgroundImages = [
    'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80', // Team collaboration
    'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1920&q=80', // Professional meeting
    'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1920&q=80', // Business presentation
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1920&q=80', // Freelancer working
    'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1920&q=80', // Office collaboration
  ];

  // Auto-rotate images every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  return (
    <section className="marketplace-hero">
      {/* Background Image Carousel */}
      <div className="hero-background-carousel">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`carousel-image ${index === currentImage ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
        <div className="hero-overlay" />
      </div>

      <div className="marketplace-hero-content">
        <div className="hero-badge">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
          <span>SOUTH AFRICA'S PREMIER FREELANCE MARKETPLACE</span>
        </div>

        <h1>Find Work. Submit Proposals. Get Hired.</h1>

        <p className="hero-description">
          Browse verified business projects from companies across South Africa. 
          Whether you're a bookkeeper, designer, developer, writer, or consultant — 
          find opportunities that match your skills. No formal qualifications required, 
          just prove your expertise and get paid for what you do best.
        </p>

        <div className="hero-value-props">
          <div className="value-prop">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <span>Browse verified business projects</span>
          </div>
          <div className="value-prop">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
            <span>Submit competitive proposals</span>
          </div>
          <div className="value-prop">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="1" x2="12" y2="23"/>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
            <span>Get paid for quality work</span>
          </div>
        </div>

        <div className="hero-stats">
            <div className="hero-stat">
            <div className="stat-number">1000+</div>
            <div className="stat-label">Youth Opportunities</div>
          </div>
          <div className="hero-stat">
            <div className="stat-number">20+</div>
            <div className="stat-label">Service Categories</div>
          </div>
        </div>

        <div className="hero-cta-buttons">
          <button className="cta-primary" onClick={onNavigateToBrowseRFQs}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            Browse Projects
            <span className="cta-subtitle">Start finding work today</span>
          </button>

          <button className="cta-secondary" onClick={onNavigateToJoinFreelancer}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            Join as Freelancer
            <span className="cta-subtitle">Create your free account</span>
          </button>
        </div>

        <div className="hero-trust-badges">
          <div className="trust-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              <path d="M9 12l2 2 4-4"/>
            </svg>
            <span>Verified Businesses</span>
          </div>
          <div className="trust-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span>Secure Platform</span>
          </div>
          <div className="trust-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="8.5" cy="7" r="4"/>
              <polyline points="17 11 19 13 23 9"/>
            </svg>
            <span>Skills Over Certificates</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;